import { Box, PageLayout } from '@primer/react';
import React, { createContext, useState } from 'react';
import { useLocation } from 'react-router-dom';
import SurveyFormGoLivePage from '../pages/crm-survey-form/SurveyFormGoLivePage';
import Header from './header';
import Menu from './menu';
export interface ILayoutContext {
    isHideSubNav?: boolean,
    setHideSubNav?: (isHidden: boolean) => void
}
export const LayoutContext = createContext<ILayoutContext>({
    isHideSubNav: false
});
interface ILayoutProps {
    children?: React.ReactNode;
}

const Layout = (props: ILayoutProps) => {
    const location = useLocation(); // Sử dụng useLocation để lấy đường dẫn
    const currentUrl = location.pathname; // Sử dụng pathname thay vì window.location.href
    const [isHideSubNav, setIsHideSubNav] = useState(false);

    const contextValue: ILayoutContext = {
        isHideSubNav,
        setHideSubNav: setIsHideSubNav
    }
    if (currentUrl.includes("/crm_survey_register/")) {
        const params = currentUrl.replace('/crm_survey_register/', '').split('/');
        const dm_chiendich_id = (params.length > 0 ? parseInt(params[1]) : 0);
        const crm_survey_form_id = (params.length > 1 ? parseInt(params[2]) : 0);
        return (
            <SurveyFormGoLivePage
                isAttendance={false}
                crm_survey_form_id={crm_survey_form_id}
                dm_chiendich_id={dm_chiendich_id}
            />
        );
    } else {
        return (
            <LayoutContext.Provider value={contextValue}>
                <PageLayout containerWidth="full" sx={{ padding: 0 }}>
                    <>
                        {!currentUrl.includes("crm_survey_register") && (
                            <PageLayout.Header sx={{ marginBottom: 0 }}>
                                <Header />
                            </PageLayout.Header>
                        )}
                        {isHideSubNav !== true &&
                            <PageLayout.Pane
                                sx={{
                                    maxWidth: "200px",
                                    width: "200px",
                                    marginRight: "0px!important",
                                }}
                                position={'start'}
                            >
                                <Box
                                    height={window.innerHeight - 90}
                                    overflow={"auto"}
                                    sx={{
                                        borderRightWidth: "1px",
                                        borderRightStyle: "solid",
                                        borderRightColor: "border.default",
                                        m: 0
                                    }}
                                >
                                    <Menu />
                                </Box>
                            </PageLayout.Pane>
                        }
                        <PageLayout.Content sx={{ p: 0 }}>
                            <Box height={window.innerHeight - 90} overflow={"auto"} className='page'>
                                {props.children}
                            </Box>
                        </PageLayout.Content>
                    </>
                </PageLayout>
            </LayoutContext.Provider>
        );
    }
};

export default Layout;
